import React from 'react';
import { PropTypes } from 'prop-types';
import { Button } from '@mantine/core';
import { ArrowRight, ShoppingCart } from 'tabler-icons-react';
import AppFlexbox from '../../common/AppFlexbox';
import AppStack from '../../common/AppStack';
import AppText from '../../common/AppText';

const ClearCartConfirmation = ({
  regAssociation,
  onClose,
  onContinue,
  loading,
  isRegistration
}) => (
  <AppStack>
    <AppStack style={{ gap: 8, alignItems: 'center' }}>
      <ShoppingCart size={100} />
      <AppText style={{ textAlign: 'center' }}>
        Your cart contains items from another association. Please clear your
        cart to add {isRegistration ? 'registrations' : 'products'} from{' '}
        <span style={{ fontWeight: 500 }}>
          {regAssociation.association.name}
        </span>
        .
      </AppText>
    </AppStack>

    <AppFlexbox style={{ flex: 1 }}>
      <Button
        color="dark"
        disabled={loading}
        onClick={onClose}
        style={{ flex: 1 }}
        variant="outline"
      >
        Cancel
      </Button>

      <Button
        color="blue"
        loading={loading}
        onClick={onContinue}
        rightSection={<ArrowRight />}
        style={{ flex: 1 }}
      >
        Clear cart and continue
      </Button>
    </AppFlexbox>
  </AppStack>
);

ClearCartConfirmation.propTypes = {
  onClose: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  regAssociation: PropTypes.object.isRequired,
  isRegistration: PropTypes.bool,
  loading: PropTypes.bool
};

export default ClearCartConfirmation;
